import { FlexibleDates } from './actionTypes';
import { Config, DateUtils } from '../../utils';
import { cacheKey, getTripTypeKey } from './reducer';
import { doRequest } from '../../utils/URLUtils';

export const requestFlexibleDates = ({ origin, destination, date, tripType }) => ({
    type: FlexibleDates.REQUEST,
    payload: { origin, destination, date, tripType },
});

export const receiveFlexibleDates = ({ origin, destination, date, tripType, data }) => ({
    type: FlexibleDates.RECEIVE,
    payload: { origin, destination, date, tripType, data },
});

export const failedFlexibleDates = ({ origin, destination, date, tripType }) => ({
    type: FlexibleDates.FAILED,
    payload: { origin, destination, date, tripType },
});

const fetchFlexibleDates = ({ daysWithFares, origin, destination, date, tripType }) => (
    dispatch,
) => {
    dispatch(requestFlexibleDates({ origin, destination, date, tripType }));
    const url = '/travel/service/flow/flexibledates/prices';
    const params = {
        destinationGeoNode: destination.geoNodeId,
        originGeoNode: origin.geoNodeId,
        departureDate: DateUtils.toString(date),
        interfaceClient: 'ONE_FRONT_SMARTPHONE',
        tripType: getTripTypeKey(tripType),
        site: Config.get('website'),
        numberOfFutureDaysDep: daysWithFares,
    };

    return doRequest(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    })
        .then((response) => response.json())
        .then((data) => {
            if (data.errors !== null) {
                throw new Error(data.errors.message);
            }
            return data;
        })
        .then((data) =>
            dispatch(receiveFlexibleDates({ origin, destination, date, tripType, data })),
        )
        .catch(() => dispatch(failedFlexibleDates({ origin, destination, date, tripType })));
};

const hasCache = (cache, date, daysWithFares) => {
    if (!cache) {
        return false;
    }
    const dayInMS = 24 * 60 * 60 * 1000;
    const cacheValidTimestamp = (daysWithFares - 1) * dayInMS;
    const timestamp = date.getTime();

    return !!Object.keys(cache.status)
        .map((key) => parseInt(key))
        .find((key) => key <= timestamp && key + cacheValidTimestamp > timestamp);
};

export const getFlexibleDates = ({ daysWithFares, origin, destination, date, tripType }) => (
    dispatch,
    getState,
) => {
    if (!origin || !destination || !date) {
        return Promise.reject('Missing param');
    }
    const { flexibleDates } = getState();
    const key = cacheKey(origin, destination, tripType);

    const cache = flexibleDates[key];
    if (!hasCache(cache, date, daysWithFares)) {
        return dispatch(fetchFlexibleDates({ daysWithFares, origin, destination, date, tripType }));
    }
    return Promise.resolve();
};
